<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 0px;">
      <baidu-map
            class="map"
            :center="centerName"
            :zoom="15"
            @click="getClickInfo"
            :scroll-wheel-zoom="true"
            :mapClick="false">

          <bm-marker :position="center" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>

          <bm-control :offset="{ width: '10px', height: '10px'}">
            <bm-auto-complete v-model="addressInfo" :sugStyle="{ zIndex: 999999 }">
              <el-input v-model="addressInfo" placeholder="请输入搜索关键字" style="margin:10px 0 0 10px">
                <template slot="prepend"><span>地址搜索：</span></template>
              </el-input>
            </bm-auto-complete>
          </bm-control>

          <bm-local-search
              :keyword="addressInfo"
              :auto-viewport="true"
              style="width:0px;height:0px;overflow: hidden;">
          </bm-local-search>
          <bm-circle
              v-model="circlePath.radius"
              :center="circlePath.centerStr"
              :radius="circlePath.radius"
              stroke-color="blue"
              :stroke-opacity="0.5"
              :stroke-weight="2"
              @lineupdate="updateCirclePath">
          </bm-circle>
        </baidu-map>
      </div>
      <div class="modal-footer">
        <el-row style="width:100%">
          <el-col :span="21">
            <el-col :span="12" style="padding:0 5px ">
              <el-input type="number" v-model="circlePath.radius" >
                <template slot="prepend"><span>半径范围：</span></template>
                <template slot="append"><span>米</span></template>
              </el-input>
            </el-col>
            <el-col :span="12" style="padding:0 20px ">
              <el-select v-model="warning" placeholder="选择报警类型" style="width:70%" clearable>
                <el-option
                    v-for="item in warningValue"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="24 " style="padding:10px 5px ">
              <span>地址：</span>
              <el-input v-model="address" style="width:70%"></el-input>
            </el-col>

          </el-col>
          <el-col :span="3">
            <el-button style="float: right;margin-right:10px" type="primary" @click="submit">提交</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
</template>

<script>


import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "addHospital",
  data() {
    return {
      userDeviceCode:'',
      warning: '',

      warningValue: [{
        value: 'out', label: '出'
      }, {
        value: 'in', label: '进'
      }],
      centerName:{
        lng: '',
        lat: ''
      },
      center: {
        lng: '',
        lat: ''
      },
      addressInfo:'',
      zoom: '',
      circlePath:{
        centerStr: {
          lng: '',
          lat: ''
        },
        radius:''
      },
      address:'',



    };
  },
  components: {

  },
  methods: {
    init(userDeviceCode) {

      this.userDeviceCode=userDeviceCode;
      this.circlePath.radius='';
      this.warning='';
      this.center.lat='';
      this.center.lng='';
      this.circlePath.centerStr=this.center;
      this.centerName=this.center;
      this.addressInfo='';
      this.address='';
      this.getWeiLanInfo();

    },

    closeSelf() {
      this.$emit('closeBaiduMapRail')
    },
    getClickInfo(e){
      this.center.lng=e.point.lng;
      this.center.lat=e.point.lat;
    },
    updateCirclePath(){
        this.circlePath.centerStr = this.center;
    },
    getWeiLanInfo(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "Positioning/WeiLanInfo",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userDeviceCode:this.userDeviceCode,
        }
      }).then((response) => {
            if (response.data.error === 0) {

              if(response.data.data!=null){

                this.circlePath.radius=response.data.data.distance;
                this.warning=response.data.data.alertType;

                let dd = this.bd_encrypta(response.data.data.lon,response.data.data.lat);

                this.center.lng=dd[0];//response.data.data.lon;
                this.center.lat=dd[1];//response.data.data.lat;


                this.circlePath.centerStr=this.center;
                this.centerName=this.center;
                this.address=response.data.data.address
              }else {
                this.circlePath.radius='';
                this.centerName = {lng:116.394783,lat:39.937289};

              }

            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          })
    },
    submit(){
      if(this.circlePath.radius===''){
        this.$message({type: 'info', message: '请设置半径!'});
      }
      if(this.center.lat===''||this.center.lng===''){
        this.$message({type: 'info', message: '请选择具体位置!'});
      }

      let dd = this.bMapTransWXMap(this.center.lng,this.center.lat);


      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "Positioning/WeiLan",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userDeviceCode:this.userDeviceCode,
          lat:dd[1],
          lon:dd[0],
          distance:this.circlePath.radius,
          alertType:this.warning,
          address:this.address
        }
      }).then((response) => {
            if (response.data.error === 0) {
              console.log(response.data.data)
              this.$message({type: 'success', message: '保存成功'});
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          })
    },


    // GCJ-02 to BD-09
    bd_encrypta(gg_lon, gg_lat) {
      var X_PI = Math.PI * 3000.0 / 180.0;
      var x = gg_lon, y = gg_lat;
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
      var bd_lon = z * Math.cos(theta) + 0.0065;
      var bd_lat = z * Math.sin(theta) + 0.006;
      return [bd_lon, bd_lat]
    },

    // BD-09 to GCJ-02
    bMapTransWXMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);
      return [lngs, lats]
    },

  }
};

</script>

<style>

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}


</style>



<style lang="scss" scoped>
.map{
  width: 100%;
  height: 250px;
}
.modal-footer {
  border-top: 1px solid #eee;
  // justify-content: flex-end;
  padding: 15px;
  // display: flex;
}

/deep/ .el-input.is-disabled .el-input__inner{
  background-color: #fff;
  border-color: #DCDFE6;
  color:#606266;
  cursor: not-allowed;
}

</style>
